import { getAnalytics } from '@/utils/Analytics';
import Image from 'next/image';
import Link from 'next/link';

const DESKTOP_HREF =
    'https://www.kotakneo.com/platform/kotak-neo-trade-api/?utm_source=Branding_2026&utm_campaign=Openbroker_JAS_2026&utm_content=1208x170';
const MOBILE_HREF = 'https://www.kotakneo.com/?utm_source=Branding_2026&utm_campaign=Openbroker_JAS_2026&utm_content=344x170';

const BANNER_ALT = '₹0 Brokerage for all API orders via Kotak Neo. Open Demat Account.';

const { mixpanel } = getAnalytics();

const PromotionBanner = () => {
    const handleLinkClick = (variant: 'desktop' | 'mobile') => {
        if (mixpanel) {
            mixpanel.track('Kotak Neo Banner Link Clicked', {
                origin: 'Openbroker',
                variant,
            });
        }
    };

    return (
        <>
            <Link
                href={MOBILE_HREF}
                target='_blank'
                rel='noreferrer noopener'
                onClick={() => handleLinkClick('mobile')}
                className='mx-auto block w-full max-w-[344px] overflow-hidden sm:hidden'>
                <Image src='/promotions/kotak-neo-banner-mobile.png' alt={BANNER_ALT} width={344} height={170} className='block h-auto w-full' />
            </Link>
            <Link
                href={DESKTOP_HREF}
                target='_blank'
                rel='noreferrer noopener'
                onClick={() => handleLinkClick('desktop')}
                className='hidden w-full min-w-0 sm:block'>
                <Image
                    src='/promotions/kotak-neo-banner-desktop.png'
                    alt={BANNER_ALT}
                    width={1208}
                    height={170}
                    className='block h-auto w-full max-w-full'
                />
            </Link>
        </>
    );
};

export default PromotionBanner;
